/* tslint:disable */
/* eslint-disable */
/**
 * My App API
 * My App API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ApplicationCertificateTypeProgramTypeResponse,
    ApplicationCertificateTypeProgramTypeResponseFromJSON,
    ApplicationCertificateTypeProgramTypeResponseFromJSONTyped,
    ApplicationCertificateTypeProgramTypeResponseToJSON,
    Attachment,
    AttachmentFromJSON,
    AttachmentFromJSONTyped,
    AttachmentToJSON,
} from './';

/**
 * 
 * @export
 * @interface ApplicationCertificateResponse
 */
export interface ApplicationCertificateResponse {
    /**
     * 
     * @type {number}
     * @memberof ApplicationCertificateResponse
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof ApplicationCertificateResponse
     */
    applicationCertificateTypeId: number;
    /**
     * 
     * @type {number}
     * @memberof ApplicationCertificateResponse
     */
    programTypeId: number;
    /**
     * 
     * @type {Array<Attachment>}
     * @memberof ApplicationCertificateResponse
     */
    attachments?: Array<Attachment>;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationCertificateResponse
     */
    required: boolean;
    /**
     * 
     * @type {ApplicationCertificateTypeProgramTypeResponse}
     * @memberof ApplicationCertificateResponse
     */
    applicationCertificateTypeProgramType?: ApplicationCertificateTypeProgramTypeResponse;
}

export function ApplicationCertificateResponseFromJSON(json: any): ApplicationCertificateResponse {
    return ApplicationCertificateResponseFromJSONTyped(json, false);
}

export function ApplicationCertificateResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApplicationCertificateResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'applicationCertificateTypeId': json['applicationCertificateTypeId'],
        'programTypeId': json['programTypeId'],
        'attachments': !exists(json, 'attachments') ? undefined : ((json['attachments'] as Array<any>).map(AttachmentFromJSON)),
        'required': json['required'],
        'applicationCertificateTypeProgramType': !exists(json, 'applicationCertificateTypeProgramType') ? undefined : ApplicationCertificateTypeProgramTypeResponseFromJSON(json['applicationCertificateTypeProgramType']),
    };
}

export function ApplicationCertificateResponseToJSON(value?: ApplicationCertificateResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'applicationCertificateTypeId': value.applicationCertificateTypeId,
        'programTypeId': value.programTypeId,
        'attachments': value.attachments === undefined ? undefined : ((value.attachments as Array<any>).map(AttachmentToJSON)),
        'required': value.required,
        'applicationCertificateTypeProgramType': ApplicationCertificateTypeProgramTypeResponseToJSON(value.applicationCertificateTypeProgramType),
    };
}


